import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import SelfDevelopmentUserDetail from './SelfDevelopmentUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanySelfDevelopmentUserDetail } from './companySelfDevelopmentApi';

/**
 * Company Self Development → one employee's/member's practice.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CSelfDevelopmentUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Self Development | Shoorah</title>
      </Helmet>
      <SelfDevelopmentUserDetail
        fetcher={fetchCompanySelfDevelopmentUserDetail}
        backPath={`/${slug}/self-development/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CSelfDevelopmentUserDetail;
